import { Opts } from 'src/lib/ui/components/ButtonScaleViewWithText';
import i18n from 'src/lib/i18n/i18n';
import { startInstallNativeSequence } from './native.sequence';
import { Feature } from 'src/replicant/analytics';
import { guessInstalledNativeAppPlatform } from './native.util';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { ImageScaleView, animate } from '@play-co/timestep-core/ui';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';
import { LangBitmapFontTextShadowView } from '../../lib/ui/components/LangBitmapFontTextShadowView';
import StateObserver from '../../StateObserver';
import { setFlag } from '../../state/ui';
import { animDuration } from '../../lib/utils';

export default class NativeAppPromoButton extends ButtonScaleView {
  constructor(opts: Omit<Opts, 'tracking'>) {
    super({
      width: 154,
      height: 157,
      pressedOffsetY: 5,
      ...opts,
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature: Feature.NATIVE.PROMO_BUTTON,
      },
    });

    const image = new ImageScaleView({
      superview: this,
      image: 'assets/native/btn_nativeapp.png',
      width: 154,
      height: 157,
    });

    const textWidth = 106;
    new LangBitmapFontTextShadowView({
      superview: image,
      color: '#FFFFFF',
      size: 18,
      font: 'Body',
      textShadowOffsetX: 0,
      textShadowOffsetY: 2,
      textShadowColor: '#843C24',
      x: (154 - textWidth) / 2 + 2, // Center horizontally: (button width - text width) / 2 + (small offset)
      y: 114,
      width: textWidth,
      height: 30,
      wordWrap: false,
      localeText: () => i18n('native.install.button.bannerLabel'),
      align: 'center',
      verticalAlign: 'center',
    });
  }

  public async onClick() {
    // Mark button and its UI as seen in this session
    StateObserver.dispatch(
      setFlag({ key: 'nativePromoSessionSeen', value: true }),
    );

    if (guessInstalledNativeAppPlatform() === null) {
      return startInstallNativeSequence({ originFeature: 'home_icon' });
    }

    await openPopupPromise('popupLoginCrossplay', {
      origin: 'hud',
      originFeature: 'home_icon',
    });
  }

  public async fadeOut() {
    await animate(this)
      .now({ opacity: 0 }, animDuration)
      .then(() => this.hide())
      .toPromise();
  }
}
